var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Image } from "../Image";
import { PickedEvent, ItemState } from "../PickedEvent";
import { observable, action, computed } from "mobx";
export var LoginRestriction;
(function (LoginRestriction) {
    LoginRestriction[LoginRestriction["LoggedInOnly"] = 2] = "LoggedInOnly";
    LoginRestriction[LoginRestriction["LoggedOutOnly"] = 1] = "LoggedOutOnly";
    LoginRestriction[LoginRestriction["All"] = 0] = "All";
})(LoginRestriction || (LoginRestriction = {}));
export class SuperBannerItem {
    constructor(source, clientIncludeInManager) {
        this.AllowDevices = source.AllowDevices;
        this.FreeHtmlText = source.FreeHtmlText;
        this.Id = source.Id;
        this.Image = source.Image ? new Image(source.Image) : undefined;
        this.Link = source.Link;
        this.LoginControl = source.LoginControl || 0;
        this.Name = source.Name;
        this.PickedEvent = source.PickedEvent ? new PickedEvent(source.PickedEvent) : undefined;
        this.state = ItemState.unavailable;
        this.SportId = source.SportId;
        this.ClientHashClass = clientIncludeInManager.getElementClass(source.HashClientIncludeIn);
        this.ClientHashAttribute = source.HashClientIncludeIn;
    }
    /* istanbul ignore next */
    setState(state) {
        this.state = state;
    }
    /* istanbul ignore next */
    get IsLoading() {
        /* istanbul ignore next */
        return (this.PickedEvent === undefined && this.state === ItemState.loading) ||
            (!!this.PickedEvent && this.PickedEvent.state === ItemState.loading);
    }
}
__decorate([
    observable,
    __metadata("design:type", PickedEvent)
], SuperBannerItem.prototype, "PickedEvent", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], SuperBannerItem.prototype, "state", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerItem.prototype, "setState", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], SuperBannerItem.prototype, "IsLoading", null);
//# sourceMappingURL=SuperBannerItem.js.map